import { useCheckboxState } from '../abstract/checkbox';

export function useFurnishedFilter({
  config,
  query,
  setFilters,
  updateQuery,
}) {
  let { checked: furnished, setChecked: onFurnishedChange } = useCheckboxState({
    defaultValue: query.furnished,
    filterKey: `furnished`,
    setFilters,
    updateQuery,
  });

  return { furnished, onFurnishedChange };
}
